import Glider from '../../../js/glider'

require('./_image-carousel.scss')
require('../../../js/glider')

const LINKED_TEXT_ELEMENTS = '.image-carousel__item-cta.link.link--secondary';

const ImageCarousel = {

  init: function (element) {
    const _ = this
    const gliderElement = element.querySelector('.glider')
    const autoplayEnabled = element.classList.contains('autoplay')

    if (autoplayEnabled === true) {
      // autoplayDuration value in seconds
      const autoplayDuration = element.attributes['data-autoplay-duration'].value * 1000

      if (autoplayDuration > 0) {
        // bind glider-slide-visible event only if autoplayEnabled is true and autoplayDuration > 0
        gliderElement.addEventListener('glider-loaded', (event) => {
          gliderElement.setAttribute('data-current-slide', 0)
          let interval = null
          interval = _.startSlideshow(gliderElement, autoplayDuration, interval, _)
          const pauseButton = element.querySelector('.carousel__button--pause')
          if (pauseButton !== null) {
            pauseButton.classList.add('playing')
            pauseButton.addEventListener('click', (e) => { _.pauseSlideshow_toggle(e.currentTarget, gliderElement, autoplayDuration, interval, _) })
          }
        })
      }
    }

    const glider = new Glider(gliderElement, {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,

      arrows: {
        prev: element.querySelector('.glider-prev'),
        next: element.querySelector('.glider-next')
      },
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    })
    window.addEventListener('load', () => {
      setTimeout(() => { glider.refresh() }, 1000)
    });
    const linkTextElements = element.querySelectorAll(LINKED_TEXT_ELEMENTS) ;
    this.hideAllLinkText(linkTextElements);
  },
  startSlideshow: (gliderElement, autoplayDuration, interval, _) => {
    interval = setInterval(() => { _.playNextSlide(gliderElement) }, autoplayDuration)
    return interval
  },
  pauseSlideshow: (_, interval) => {
    window.clearInterval(interval)
  },
  playNextSlide: (gliderElement) => {
    const glider = Glider(gliderElement)

    let nextSlide = glider.slide + 1
    if (glider.slides[glider.slides.length - 1].classList.contains('visible')) {
      nextSlide = 0
    }

    glider.scrollItem(nextSlide)
    gliderElement.setAttribute('data-current-slide', nextSlide)
  },
  pauseSlideshow_toggle: (el, gliderElement, autoplayDuration, interval, _) => {
    if (_.IsAutoplayPaused(gliderElement)) {
      _.playNextSlide(gliderElement)
      _.startSlideshow(gliderElement, autoplayDuration, interval, _)
      el.classList.remove('paused')
      el.classList.add('playing')
      el.attributes['aria-label'].value = 'Pause slideshow'
    } else {
      _.pauseSlideshow(_, interval)
      el.classList.remove('playing')
      el.classList.add('paused')
      el.attributes['aria-label'].value = 'Play slideshow'
    }
  },
  IsAutoplayPaused: (gliderElement) => {
    const pauseButton = gliderElement.parentNode.parentNode.querySelector('.carousel__button--pause')
    return pauseButton.classList.contains('paused')
  },
  hideAllLinkText: (linkTextElements) => {
    for(const linkTextElement of linkTextElements) {
      linkTextElement.style.display = "none";
    }
  }

}

export default ImageCarousel
